import { Box, Button, Flex, FormControl, FormLabel, Switch } from "@chakra-ui/react";
import moment from "moment";
import { useState } from "react";
import WeekCalendar from "components/Calendar/WeekCalendar";
import { CalendarEvent } from "components/Calendar/types";
import type { PreviewAction } from "../types";
import { previewActionsToCalendarEvents } from "../helpers";

interface PreviewWeekViewProps {
  actions: PreviewAction[];
  startDate: string;
  timezone: string;
  onEventClick?: (event: CalendarEvent) => void;
}

export default function PreviewWeekView({ actions, startDate, timezone, onEventClick }: PreviewWeekViewProps) {
  const [weekStart, setWeekStart] = useState(() => moment.tz(startDate, timezone).startOf("isoWeek"));
  const [showWeekends, setShowWeekends] = useState(false);

  const events = previewActionsToCalendarEvents(actions, timezone);

  const weekEnd = showWeekends ? weekStart.clone().add(6, "days") : weekStart.clone().add(4, "days");

  return (
    <Flex direction="column" width="100%">
      <Flex justify="space-between" align="center" px="4" py="2">
        <FormControl display="flex" alignItems="center" width="auto">
          <FormLabel htmlFor="preview-weekends-week" mb="0" fontSize="sm">
            Show weekends
          </FormLabel>
          <Switch
            id="preview-weekends-week"
            isChecked={showWeekends}
            onChange={(e) => setShowWeekends(e.target.checked)}
          />
        </FormControl>
        <Box fontWeight="bold" fontSize="lg">
          {weekStart.format("MMM D")} – {weekEnd.format("MMM D, YYYY")}
        </Box>
        <Flex gap="2">
          <Button size="sm" variant="outline" onClick={() => setWeekStart(weekStart.clone().subtract(1, "week"))}>
            ← Prev
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() => setWeekStart(moment.tz(startDate, timezone).startOf("isoWeek"))}
          >
            Start Day
          </Button>
          <Button size="sm" variant="outline" onClick={() => setWeekStart(weekStart.clone().add(1, "week"))}>
            Next →
          </Button>
        </Flex>
      </Flex>
      <WeekCalendar
        events={events}
        onUpdate={() => {}}
        onCreate={() => {}}
        onEventClick={onEventClick || (() => {})}
        startDate={weekStart.toDate()}
        timezone={timezone}
        showWeekends={showWeekends}
        editable={false}
      />
    </Flex>
  );
}
